import {
  HeaderCellOptionsProps,
  ManageFilterOptionsProps,
  TableHeaderCellOptions,
} from './table.types'

const makeManageFilterOptions = (
  headerCellOptions: TableHeaderCellOptions
): ManageFilterOptionsProps => {
  type headerCellKeyType = keyof typeof headerCellOptions

  const reduceFilterColumns = (filterType: keyof HeaderCellOptionsProps) =>
    Object.keys(headerCellOptions).reduce((acc, key) => {
      const column = headerCellOptions[key as headerCellKeyType]
      return column?.[filterType] ? [...acc, key] : acc
    }, [] as string[])

  const columnLabel = Object.keys(headerCellOptions).reduce((acc, key) => {
    const column = headerCellOptions[key as headerCellKeyType]
    return { ...acc, [key]: column?.title ?? '' }
  }, {})

  const dateFilterColumns = reduceFilterColumns('dateFilter')
  const rangeFilterColumns = reduceFilterColumns('rangeFilter')
  const searchFilterColumns = reduceFilterColumns('searchFilter')
  const selectSearchFilterColumns = reduceFilterColumns('selectSearchFilter')

  const selectOptions = selectSearchFilterColumns.reduce(
    (acc, column) => ({
      ...acc,
      [column]: headerCellOptions[column]?.selectOptions || [],
    }),
    {}
  )

  return {
    columnLabel,
    dateFilterColumns,
    rangeFilterColumns,
    searchFilterColumns,
    selectOptions,
    selectSearchFilterColumns,
  }
}

export { makeManageFilterOptions }
